// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardimg2 {
    width: 172px; 
    height: 160px;
    cursor: pointer;
}

.cardimg {
    cursor: pointer;
}

@media (min-width: 600px) and (max-width: 969px){
    .firstheader {
        margin-left: 20px;
        height: 15px; 
        width: 22px; 
        border: 1px solid #000000;
        border-radius: 3px;
        display: inline
    } 

    .cardimg2 {
        width: 160px; 
        height: 150px;
        cursor: pointer;
    }

    .cardimg {
        width: 172px; 
        height: 160px;
        cursor: pointer;
    }
}


@media (min-width: 100px) and (max-width: 293px){
    .cardimg2 {
        width: 160px; 
        height: 150px;
        cursor: pointer;
    }

    .cardimg {
        width: 172px; 
        height: 160px; 
        cursor: pointer;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/courseCards.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,kBAAkB;QAClB;IACJ;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;AACJ","sourcesContent":[".cardimg2 {\n    width: 172px; \n    height: 160px;\n    cursor: pointer;\n}\n\n.cardimg {\n    cursor: pointer;\n}\n\n@media (min-width: 600px) and (max-width: 969px){\n    .firstheader {\n        margin-left: 20px;\n        height: 15px; \n        width: 22px; \n        border: 1px solid #000000;\n        border-radius: 3px;\n        display: inline\n    } \n\n    .cardimg2 {\n        width: 160px; \n        height: 150px;\n        cursor: pointer;\n    }\n\n    .cardimg {\n        width: 172px; \n        height: 160px;\n        cursor: pointer;\n    }\n}\n\n\n@media (min-width: 100px) and (max-width: 293px){\n    .cardimg2 {\n        width: 160px; \n        height: 150px;\n        cursor: pointer;\n    }\n\n    .cardimg {\n        width: 172px; \n        height: 160px; \n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
